import React from 'react';

import { L10n } from '~commonInfra/L10n/L10n';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';

import { cssClass } from '../../../style';
import { SpaceContainerStyles } from '../../style/SpaceContainerStyles';
import { SpaceHeaderContent } from './SpaceHeaderContent';

export const spaceHeaderID = 'space-header';

export interface SpaceHeaderWithTotalItemsCountProps {
  readonly label: string;
  readonly count: number;
  readonly countUpToDate: boolean;
  readonly testId: string;
  readonly onClick: () => void;
  readonly licenseInfoBar?: () => JSX.Element;
  readonly shouldHideCount?: boolean;
}

export function SpaceHeaderWithTotalItemsCount(props: SpaceHeaderWithTotalItemsCountProps) {

  // Render empty count until we get an update to date count and then
  // just render a number from there on out.
  const [countUpToDate, setCountUpToDate] = React.useState(props.countUpToDate);
  React.useEffect(() => {
    if (props.countUpToDate) {
      setCountUpToDate(true);
    }
  }, [props.countUpToDate]);

  return (
    <div className={SpaceContainerStyles.MastheadArea}>
      <SpaceHeaderContent headerText={props.label} renderSideContent={() => {
        return !props.shouldHideCount && <div className={Styles.Count} data-tb-test-id={props.testId + '-header-count'}>
          {countUpToDate ? L10n.localizedCount(props.count) : ''}
        </div>;
      }} onClick={props.onClick} />
      {props.licenseInfoBar && props.licenseInfoBar()}
    </div>
  );
}

namespace Styles {

  export const Count = cssClass('space-header', 'count', {
    color: CommonStyles.Colors.AccessibleSecondaryTextColor,
    fontSize: '14px'
  });
}
